import { Component, Input } from '@angular/core';
import { DividerModule } from 'primeng/divider';
import { SocialLinksComponent } from "../../../core/social-links/feature/social-links.component";
import { EventSystemDetailed } from '../../../data-services/models/event-systems/event-system-detailed.model';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-event-system-headline',
  imports: [DividerModule,SocialLinksComponent,RouterModule],
  templateUrl: '../ui/headline.component.html',
  styleUrl: '../ui/headline.component.css'
})
export class EventSystemHeadlineComponent {
  @Input() system?: EventSystemDetailed;
}
